module.exports = __webpack_public_path__ + "static/Efficiencies 3-511d8683099fb23ac589456cdf308650.png";